import React,{useState} from 'react';

const Ping = (props) => {
    return (<>
        <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%',width:'100%',fontSize:'30px'}}>
                OK
        </div>
    </>)
}

export default Ping;
